import type { Control } from 'react-hook-form';
import { useIsFieldReadOnly } from 'src/components/form/form/customisable-form/hooks/useIsFieldReadOnly';
import type { ThirdPartyOption } from 'src/hooks/queries/third-party/useGetThirdPartyOptions';
import type { IssueAssessmentFields } from 'src/pages/issues/update/forms/issue-assessment-form/issueAssessmentSchema';

interface UseResponsibleThirdPartyAutosuggestArgs {
  control: Control<IssueAssessmentFields>;
  disabled?: boolean;
  isLoading: boolean;
  name: 'ThirdPartyResponsible';
  thirdPartyOptions: readonly ThirdPartyOption[];
}

export const useResponsibleThirdPartyAutosuggest = ({
  control,
  disabled,
  isLoading,
  name,
  thirdPartyOptions,
}: UseResponsibleThirdPartyAutosuggestArgs) => {
  const { error } = control.getFieldState(name);
  const readOnly = useIsFieldReadOnly(name);

  return {
    props: {
      disabled: readOnly || !!disabled,
      errorText: error?.message,
      options: thirdPartyOptions.map((thirdParty) => ({
        label: thirdParty.Title,
        value: thirdParty.Id,
      })),
      statusType: isLoading ? ('loading' as const) : ('finished' as const),
    },
  };
};
